"use strict";
/**
 * @fileoverview gRPC-Web generated client stub for cache_client
 * @enhanceable
 * @public
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScsClient = void 0;
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck
const grpcWeb = __importStar(require("grpc-web"));
const cacheclient_pb = __importStar(require("./cacheclient_pb"));
class ScsClient {
    constructor(hostname, credentials, options) {
        this.methodDescriptorGet = new grpcWeb.MethodDescriptor('/cache_client.Scs/Get', grpcWeb.MethodType.UNARY, cacheclient_pb._GetRequest, cacheclient_pb._GetResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._GetResponse.deserializeBinary);
        this.methodDescriptorSet = new grpcWeb.MethodDescriptor('/cache_client.Scs/Set', grpcWeb.MethodType.UNARY, cacheclient_pb._SetRequest, cacheclient_pb._SetResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SetResponse.deserializeBinary);
        this.methodDescriptorSetIfNotExists = new grpcWeb.MethodDescriptor('/cache_client.Scs/SetIfNotExists', grpcWeb.MethodType.UNARY, cacheclient_pb._SetIfNotExistsRequest, cacheclient_pb._SetIfNotExistsResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SetIfNotExistsResponse.deserializeBinary);
        this.methodDescriptorDelete = new grpcWeb.MethodDescriptor('/cache_client.Scs/Delete', grpcWeb.MethodType.UNARY, cacheclient_pb._DeleteRequest, cacheclient_pb._DeleteResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._DeleteResponse.deserializeBinary);
        this.methodDescriptorKeysExist = new grpcWeb.MethodDescriptor('/cache_client.Scs/KeysExist', grpcWeb.MethodType.UNARY, cacheclient_pb._KeysExistRequest, cacheclient_pb._KeysExistResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._KeysExistResponse.deserializeBinary);
        this.methodDescriptorIncrement = new grpcWeb.MethodDescriptor('/cache_client.Scs/Increment', grpcWeb.MethodType.UNARY, cacheclient_pb._IncrementRequest, cacheclient_pb._IncrementResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._IncrementResponse.deserializeBinary);
        this.methodDescriptorUpdateTtl = new grpcWeb.MethodDescriptor('/cache_client.Scs/UpdateTtl', grpcWeb.MethodType.UNARY, cacheclient_pb._UpdateTtlRequest, cacheclient_pb._UpdateTtlResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._UpdateTtlResponse.deserializeBinary);
        this.methodDescriptorItemGetTtl = new grpcWeb.MethodDescriptor('/cache_client.Scs/ItemGetTtl', grpcWeb.MethodType.UNARY, cacheclient_pb._ItemGetTtlRequest, cacheclient_pb._ItemGetTtlResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ItemGetTtlResponse.deserializeBinary);
        this.methodDescriptorItemGetType = new grpcWeb.MethodDescriptor('/cache_client.Scs/ItemGetType', grpcWeb.MethodType.UNARY, cacheclient_pb._ItemGetTypeRequest, cacheclient_pb._ItemGetTypeResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ItemGetTypeResponse.deserializeBinary);
        this.methodDescriptorDictionaryGet = new grpcWeb.MethodDescriptor('/cache_client.Scs/DictionaryGet', grpcWeb.MethodType.UNARY, cacheclient_pb._DictionaryGetRequest, cacheclient_pb._DictionaryGetResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._DictionaryGetResponse.deserializeBinary);
        this.methodDescriptorDictionaryFetch = new grpcWeb.MethodDescriptor('/cache_client.Scs/DictionaryFetch', grpcWeb.MethodType.UNARY, cacheclient_pb._DictionaryFetchRequest, cacheclient_pb._DictionaryFetchResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._DictionaryFetchResponse.deserializeBinary);
        this.methodDescriptorDictionarySet = new grpcWeb.MethodDescriptor('/cache_client.Scs/DictionarySet', grpcWeb.MethodType.UNARY, cacheclient_pb._DictionarySetRequest, cacheclient_pb._DictionarySetResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._DictionarySetResponse.deserializeBinary);
        this.methodDescriptorDictionaryIncrement = new grpcWeb.MethodDescriptor('/cache_client.Scs/DictionaryIncrement', grpcWeb.MethodType.UNARY, cacheclient_pb._DictionaryIncrementRequest, cacheclient_pb._DictionaryIncrementResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._DictionaryIncrementResponse.deserializeBinary);
        this.methodDescriptorDictionaryDelete = new grpcWeb.MethodDescriptor('/cache_client.Scs/DictionaryDelete', grpcWeb.MethodType.UNARY, cacheclient_pb._DictionaryDeleteRequest, cacheclient_pb._DictionaryDeleteResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._DictionaryDeleteResponse.deserializeBinary);
        this.methodDescriptorDictionaryLength = new grpcWeb.MethodDescriptor('/cache_client.Scs/DictionaryLength', grpcWeb.MethodType.UNARY, cacheclient_pb._DictionaryLengthRequest, cacheclient_pb._DictionaryLengthResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._DictionaryLengthResponse.deserializeBinary);
        this.methodDescriptorSetFetch = new grpcWeb.MethodDescriptor('/cache_client.Scs/SetFetch', grpcWeb.MethodType.UNARY, cacheclient_pb._SetFetchRequest, cacheclient_pb._SetFetchResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SetFetchResponse.deserializeBinary);
        this.methodDescriptorSetUnion = new grpcWeb.MethodDescriptor('/cache_client.Scs/SetUnion', grpcWeb.MethodType.UNARY, cacheclient_pb._SetUnionRequest, cacheclient_pb._SetUnionResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SetUnionResponse.deserializeBinary);
        this.methodDescriptorSetDifference = new grpcWeb.MethodDescriptor('/cache_client.Scs/SetDifference', grpcWeb.MethodType.UNARY, cacheclient_pb._SetDifferenceRequest, cacheclient_pb._SetDifferenceResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SetDifferenceResponse.deserializeBinary);
        this.methodDescriptorSetContains = new grpcWeb.MethodDescriptor('/cache_client.Scs/SetContains', grpcWeb.MethodType.UNARY, cacheclient_pb._SetContainsRequest, cacheclient_pb._SetContainsResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SetContainsResponse.deserializeBinary);
        this.methodDescriptorSetLength = new grpcWeb.MethodDescriptor('/cache_client.Scs/SetLength', grpcWeb.MethodType.UNARY, cacheclient_pb._SetLengthRequest, cacheclient_pb._SetLengthResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SetLengthResponse.deserializeBinary);
        this.methodDescriptorSetPop = new grpcWeb.MethodDescriptor('/cache_client.Scs/SetPop', grpcWeb.MethodType.UNARY, cacheclient_pb._SetPopRequest, cacheclient_pb._SetPopResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SetPopResponse.deserializeBinary);
        this.methodDescriptorListPushFront = new grpcWeb.MethodDescriptor('/cache_client.Scs/ListPushFront', grpcWeb.MethodType.UNARY, cacheclient_pb._ListPushFrontRequest, cacheclient_pb._ListPushFrontResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ListPushFrontResponse.deserializeBinary);
        this.methodDescriptorListPushBack = new grpcWeb.MethodDescriptor('/cache_client.Scs/ListPushBack', grpcWeb.MethodType.UNARY, cacheclient_pb._ListPushBackRequest, cacheclient_pb._ListPushBackResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ListPushBackResponse.deserializeBinary);
        this.methodDescriptorListPopFront = new grpcWeb.MethodDescriptor('/cache_client.Scs/ListPopFront', grpcWeb.MethodType.UNARY, cacheclient_pb._ListPopFrontRequest, cacheclient_pb._ListPopFrontResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ListPopFrontResponse.deserializeBinary);
        this.methodDescriptorListPopBack = new grpcWeb.MethodDescriptor('/cache_client.Scs/ListPopBack', grpcWeb.MethodType.UNARY, cacheclient_pb._ListPopBackRequest, cacheclient_pb._ListPopBackResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ListPopBackResponse.deserializeBinary);
        this.methodDescriptorListErase = new grpcWeb.MethodDescriptor('/cache_client.Scs/ListErase', grpcWeb.MethodType.UNARY, cacheclient_pb._ListEraseRequest, cacheclient_pb._ListEraseResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ListEraseResponse.deserializeBinary);
        this.methodDescriptorListRemove = new grpcWeb.MethodDescriptor('/cache_client.Scs/ListRemove', grpcWeb.MethodType.UNARY, cacheclient_pb._ListRemoveRequest, cacheclient_pb._ListRemoveResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ListRemoveResponse.deserializeBinary);
        this.methodDescriptorListFetch = new grpcWeb.MethodDescriptor('/cache_client.Scs/ListFetch', grpcWeb.MethodType.UNARY, cacheclient_pb._ListFetchRequest, cacheclient_pb._ListFetchResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ListFetchResponse.deserializeBinary);
        this.methodDescriptorListLength = new grpcWeb.MethodDescriptor('/cache_client.Scs/ListLength', grpcWeb.MethodType.UNARY, cacheclient_pb._ListLengthRequest, cacheclient_pb._ListLengthResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ListLengthResponse.deserializeBinary);
        this.methodDescriptorListConcatenateFront = new grpcWeb.MethodDescriptor('/cache_client.Scs/ListConcatenateFront', grpcWeb.MethodType.UNARY, cacheclient_pb._ListConcatenateFrontRequest, cacheclient_pb._ListConcatenateFrontResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ListConcatenateFrontResponse.deserializeBinary);
        this.methodDescriptorListConcatenateBack = new grpcWeb.MethodDescriptor('/cache_client.Scs/ListConcatenateBack', grpcWeb.MethodType.UNARY, cacheclient_pb._ListConcatenateBackRequest, cacheclient_pb._ListConcatenateBackResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ListConcatenateBackResponse.deserializeBinary);
        this.methodDescriptorListRetain = new grpcWeb.MethodDescriptor('/cache_client.Scs/ListRetain', grpcWeb.MethodType.UNARY, cacheclient_pb._ListRetainRequest, cacheclient_pb._ListRetainResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._ListRetainResponse.deserializeBinary);
        this.methodDescriptorSortedSetPut = new grpcWeb.MethodDescriptor('/cache_client.Scs/SortedSetPut', grpcWeb.MethodType.UNARY, cacheclient_pb._SortedSetPutRequest, cacheclient_pb._SortedSetPutResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SortedSetPutResponse.deserializeBinary);
        this.methodDescriptorSortedSetFetch = new grpcWeb.MethodDescriptor('/cache_client.Scs/SortedSetFetch', grpcWeb.MethodType.UNARY, cacheclient_pb._SortedSetFetchRequest, cacheclient_pb._SortedSetFetchResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SortedSetFetchResponse.deserializeBinary);
        this.methodDescriptorSortedSetGetScore = new grpcWeb.MethodDescriptor('/cache_client.Scs/SortedSetGetScore', grpcWeb.MethodType.UNARY, cacheclient_pb._SortedSetGetScoreRequest, cacheclient_pb._SortedSetGetScoreResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SortedSetGetScoreResponse.deserializeBinary);
        this.methodDescriptorSortedSetRemove = new grpcWeb.MethodDescriptor('/cache_client.Scs/SortedSetRemove', grpcWeb.MethodType.UNARY, cacheclient_pb._SortedSetRemoveRequest, cacheclient_pb._SortedSetRemoveResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SortedSetRemoveResponse.deserializeBinary);
        this.methodDescriptorSortedSetIncrement = new grpcWeb.MethodDescriptor('/cache_client.Scs/SortedSetIncrement', grpcWeb.MethodType.UNARY, cacheclient_pb._SortedSetIncrementRequest, cacheclient_pb._SortedSetIncrementResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SortedSetIncrementResponse.deserializeBinary);
        this.methodDescriptorSortedSetGetRank = new grpcWeb.MethodDescriptor('/cache_client.Scs/SortedSetGetRank', grpcWeb.MethodType.UNARY, cacheclient_pb._SortedSetGetRankRequest, cacheclient_pb._SortedSetGetRankResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SortedSetGetRankResponse.deserializeBinary);
        this.methodDescriptorSortedSetLength = new grpcWeb.MethodDescriptor('/cache_client.Scs/SortedSetLength', grpcWeb.MethodType.UNARY, cacheclient_pb._SortedSetLengthRequest, cacheclient_pb._SortedSetLengthResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SortedSetLengthResponse.deserializeBinary);
        this.methodDescriptorSortedSetLengthByScore = new grpcWeb.MethodDescriptor('/cache_client.Scs/SortedSetLengthByScore', grpcWeb.MethodType.UNARY, cacheclient_pb._SortedSetLengthByScoreRequest, cacheclient_pb._SortedSetLengthByScoreResponse, (request) => {
            return request.serializeBinary();
        }, cacheclient_pb._SortedSetLengthByScoreResponse.deserializeBinary);
        if (!options)
            options = {};
        if (!credentials)
            credentials = {};
        options['format'] = 'text';
        this.client_ = new grpcWeb.GrpcWebClientBase(options);
        this.hostname_ = hostname;
        this.credentials_ = credentials;
        this.options_ = options;
    }
    get(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/Get', request, metadata || {}, this.methodDescriptorGet, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/Get', request, metadata || {}, this.methodDescriptorGet);
    }
    set(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/Set', request, metadata || {}, this.methodDescriptorSet, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/Set', request, metadata || {}, this.methodDescriptorSet);
    }
    setIfNotExists(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SetIfNotExists', request, metadata || {}, this.methodDescriptorSetIfNotExists, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SetIfNotExists', request, metadata || {}, this.methodDescriptorSetIfNotExists);
    }
    delete(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/Delete', request, metadata || {}, this.methodDescriptorDelete, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/Delete', request, metadata || {}, this.methodDescriptorDelete);
    }
    keysExist(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/KeysExist', request, metadata || {}, this.methodDescriptorKeysExist, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/KeysExist', request, metadata || {}, this.methodDescriptorKeysExist);
    }
    increment(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/Increment', request, metadata || {}, this.methodDescriptorIncrement, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/Increment', request, metadata || {}, this.methodDescriptorIncrement);
    }
    updateTtl(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/UpdateTtl', request, metadata || {}, this.methodDescriptorUpdateTtl, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/UpdateTtl', request, metadata || {}, this.methodDescriptorUpdateTtl);
    }
    itemGetTtl(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ItemGetTtl', request, metadata || {}, this.methodDescriptorItemGetTtl, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ItemGetTtl', request, metadata || {}, this.methodDescriptorItemGetTtl);
    }
    itemGetType(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ItemGetType', request, metadata || {}, this.methodDescriptorItemGetType, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ItemGetType', request, metadata || {}, this.methodDescriptorItemGetType);
    }
    dictionaryGet(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/DictionaryGet', request, metadata || {}, this.methodDescriptorDictionaryGet, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/DictionaryGet', request, metadata || {}, this.methodDescriptorDictionaryGet);
    }
    dictionaryFetch(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/DictionaryFetch', request, metadata || {}, this.methodDescriptorDictionaryFetch, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/DictionaryFetch', request, metadata || {}, this.methodDescriptorDictionaryFetch);
    }
    dictionarySet(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/DictionarySet', request, metadata || {}, this.methodDescriptorDictionarySet, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/DictionarySet', request, metadata || {}, this.methodDescriptorDictionarySet);
    }
    dictionaryIncrement(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/DictionaryIncrement', request, metadata || {}, this.methodDescriptorDictionaryIncrement, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/DictionaryIncrement', request, metadata || {}, this.methodDescriptorDictionaryIncrement);
    }
    dictionaryDelete(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/DictionaryDelete', request, metadata || {}, this.methodDescriptorDictionaryDelete, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/DictionaryDelete', request, metadata || {}, this.methodDescriptorDictionaryDelete);
    }
    dictionaryLength(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/DictionaryLength', request, metadata || {}, this.methodDescriptorDictionaryLength, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/DictionaryLength', request, metadata || {}, this.methodDescriptorDictionaryLength);
    }
    setFetch(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SetFetch', request, metadata || {}, this.methodDescriptorSetFetch, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SetFetch', request, metadata || {}, this.methodDescriptorSetFetch);
    }
    setUnion(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SetUnion', request, metadata || {}, this.methodDescriptorSetUnion, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SetUnion', request, metadata || {}, this.methodDescriptorSetUnion);
    }
    setDifference(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SetDifference', request, metadata || {}, this.methodDescriptorSetDifference, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SetDifference', request, metadata || {}, this.methodDescriptorSetDifference);
    }
    setContains(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SetContains', request, metadata || {}, this.methodDescriptorSetContains, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SetContains', request, metadata || {}, this.methodDescriptorSetContains);
    }
    setLength(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SetLength', request, metadata || {}, this.methodDescriptorSetLength, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SetLength', request, metadata || {}, this.methodDescriptorSetLength);
    }
    setPop(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SetPop', request, metadata || {}, this.methodDescriptorSetPop, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SetPop', request, metadata || {}, this.methodDescriptorSetPop);
    }
    listPushFront(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ListPushFront', request, metadata || {}, this.methodDescriptorListPushFront, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ListPushFront', request, metadata || {}, this.methodDescriptorListPushFront);
    }
    listPushBack(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ListPushBack', request, metadata || {}, this.methodDescriptorListPushBack, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ListPushBack', request, metadata || {}, this.methodDescriptorListPushBack);
    }
    listPopFront(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ListPopFront', request, metadata || {}, this.methodDescriptorListPopFront, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ListPopFront', request, metadata || {}, this.methodDescriptorListPopFront);
    }
    listPopBack(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ListPopBack', request, metadata || {}, this.methodDescriptorListPopBack, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ListPopBack', request, metadata || {}, this.methodDescriptorListPopBack);
    }
    listErase(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ListErase', request, metadata || {}, this.methodDescriptorListErase, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ListErase', request, metadata || {}, this.methodDescriptorListErase);
    }
    listRemove(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ListRemove', request, metadata || {}, this.methodDescriptorListRemove, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ListRemove', request, metadata || {}, this.methodDescriptorListRemove);
    }
    listFetch(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ListFetch', request, metadata || {}, this.methodDescriptorListFetch, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ListFetch', request, metadata || {}, this.methodDescriptorListFetch);
    }
    listLength(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ListLength', request, metadata || {}, this.methodDescriptorListLength, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ListLength', request, metadata || {}, this.methodDescriptorListLength);
    }
    listConcatenateFront(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ListConcatenateFront', request, metadata || {}, this.methodDescriptorListConcatenateFront, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ListConcatenateFront', request, metadata || {}, this.methodDescriptorListConcatenateFront);
    }
    listConcatenateBack(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ListConcatenateBack', request, metadata || {}, this.methodDescriptorListConcatenateBack, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ListConcatenateBack', request, metadata || {}, this.methodDescriptorListConcatenateBack);
    }
    listRetain(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/ListRetain', request, metadata || {}, this.methodDescriptorListRetain, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/ListRetain', request, metadata || {}, this.methodDescriptorListRetain);
    }
    sortedSetPut(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SortedSetPut', request, metadata || {}, this.methodDescriptorSortedSetPut, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SortedSetPut', request, metadata || {}, this.methodDescriptorSortedSetPut);
    }
    sortedSetFetch(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SortedSetFetch', request, metadata || {}, this.methodDescriptorSortedSetFetch, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SortedSetFetch', request, metadata || {}, this.methodDescriptorSortedSetFetch);
    }
    sortedSetGetScore(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SortedSetGetScore', request, metadata || {}, this.methodDescriptorSortedSetGetScore, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SortedSetGetScore', request, metadata || {}, this.methodDescriptorSortedSetGetScore);
    }
    sortedSetRemove(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SortedSetRemove', request, metadata || {}, this.methodDescriptorSortedSetRemove, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SortedSetRemove', request, metadata || {}, this.methodDescriptorSortedSetRemove);
    }
    sortedSetIncrement(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SortedSetIncrement', request, metadata || {}, this.methodDescriptorSortedSetIncrement, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SortedSetIncrement', request, metadata || {}, this.methodDescriptorSortedSetIncrement);
    }
    sortedSetGetRank(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SortedSetGetRank', request, metadata || {}, this.methodDescriptorSortedSetGetRank, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SortedSetGetRank', request, metadata || {}, this.methodDescriptorSortedSetGetRank);
    }
    sortedSetLength(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SortedSetLength', request, metadata || {}, this.methodDescriptorSortedSetLength, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SortedSetLength', request, metadata || {}, this.methodDescriptorSortedSetLength);
    }
    sortedSetLengthByScore(request, metadata, callback) {
        if (callback !== undefined) {
            return this.client_.rpcCall(this.hostname_ +
                '/cache_client.Scs/SortedSetLengthByScore', request, metadata || {}, this.methodDescriptorSortedSetLengthByScore, callback);
        }
        return this.client_.unaryCall(this.hostname_ +
            '/cache_client.Scs/SortedSetLengthByScore', request, metadata || {}, this.methodDescriptorSortedSetLengthByScore);
    }
}
exports.ScsClient = ScsClient;
